import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { API_ROUTES, BuildReleaseType, Utils } from "../utils/utils";
import { catchError, Observable, Subject, takeUntil, throwError } from "rxjs";
import { EmtAllowedSoftwareRelease, EmtAllowedSoftwareReleaseLevelDto, UpdateEmtAllowedSoftwareReleasesRequest } from "../interfaces/emt/emt-allowed-softwarer-release";
import { EmtMandatoryVersionSoftwareReleaseDto, UpdateEmtMandatoryVersionSoftwareReleaseRequest } from "../interfaces/emt/emt_mandatory-update-software-release";

@Injectable()
export class EquipmentManagenementService {

    //tenantSubject: Subject<EmtConfiguration[]>;

    constructor(
        private httpClient: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
    ){}

    setOtaSettings(tthis: any,
        otasettings: OtaSettingsViewModel[],
        callback: any = undefined,
        errorCallback: any = undefined){
        const url = this.baseUrl + API_ROUTES.API_EMT + "/ota/setotasettings";
        
        this.httpClient.post<OtaSettingsViewModel[]>(url, otasettings)
        .pipe(takeUntil(tthis.destroy$))
        .subscribe({next: response => {
            if(callback)
                callback(response);
        }, error: error => {
            Utils.writeLog(this.httpClient,this.baseUrl,error);
            if(errorCallback)
                errorCallback(error);
            }
        });   
    
    }
    getOtaSettings(tthis: any,
        level: OtaSettingsLevel,
        callback: any = undefined,
        errorCallback: any = undefined) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/ota/getotasettings";

        let params = new HttpParams()
            .set('environment', level.environment);

        if (level.tenantId) {
            params = params.set('tenantId', level.tenantId);
        }

        this.httpClient.get<OtaSettingsViewModel[]>(url, { params })
            .pipe(takeUntil(tthis.destroy$))
            .subscribe({
                next: response => {
                    if (callback)
                        callback(response);
                }, error: error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    if (errorCallback)
                        errorCallback(error);
                }
            });
    }

    getOtaEnvsSettings(tthis: any = undefined,
        callback: any = undefined,
        errorCallback: any = undefined) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/ota/getotaenvssettings";

        this.httpClient.get<OtaSettingsViewModel[]>(url)
            .pipe(takeUntil(tthis.destroy$))
            .subscribe({
                next: response => {
                    if (callback)
                        callback(response);
                }, error: error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    if (errorCallback)
                        errorCallback(error);
                }
            });
    }

    searchEquipmentConfiguration(
        tthis: any | undefined = undefined,
        level: EquipmentConfigurationLevel,
        callback: any | undefined = undefined,
        errorCallback: any | undefined = undefined)
    {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/configuration/search";
        this.httpClient.post<EquipmentConfiguration[]>(url, level)
        .pipe(takeUntil(tthis.destroy$))
        .subscribe({next: response => {
            if(callback)
                callback(response);
        }, error: error => {
            Utils.writeLog(this.httpClient,this.baseUrl,error);
            if(errorCallback)
                errorCallback(error);
            }
        });   
    }

    initEquipmentConfiguration(
        level: EquipmentConfigurationLevel,
        callback: any | undefined = undefined, 
        errorCallback: any | undefined = undefined) 
    {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/configuration";
        this.httpClient.post<EquipmentConfiguration[]>(url,level)
            .subscribe({next: response => {
                if(callback)
                    callback(response);
            }, error: error => {
                Utils.writeLog(this.httpClient,this.baseUrl,error);
                if(errorCallback)
                    errorCallback(error);
            }}
        );       
    }

    addOtaLevel(
        level: OtaSettingsLevel,
        callback: any = undefined,
        errorCallback: any = undefined)
    {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/ota/addotalevel";
        this.httpClient.post(url, level)
            .subscribe({
                next: response => {
                    if (callback)
                        callback(response);
                }, error: error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    if (errorCallback)
                        errorCallback(error);
                }
            });
    }

    initOtaSettings(
        callback: any = undefined,
        errorCallback: any = undefined)
    {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/ota/initotasettings";
        this.httpClient.post(url, null)
            .subscribe({
                next: response => {
                    if (callback)
                        callback(response);
                }, error: error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    if (errorCallback)
                        errorCallback(error);
                }
            });
    }

    updateEquipmentConfiguration(
        updateRequests: UpdateEquipmentConfigurationValueRequest[],
        callback: any | undefined = undefined, 
        errorCallback: any | undefined = undefined)
    {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/configuration";
        this.httpClient.put<UpdateEquipmentConfigurationValueRequest[]>(url,updateRequests)
            .subscribe({next: response => {
                if(callback)
                    callback(response);
            }, error: error => {
                Utils.writeLog(this.httpClient,this.baseUrl,error);
                if(errorCallback)
                    errorCallback(error);
            }}
        );
    }

    getUserLevels(callback: any | undefined = undefined, errorCallback: any | undefined = undefined)
    {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/configuration/levels";
        this.httpClient.get(url).subscribe({
            next: response => {
                if(callback)
                    callback(response);
            }, error: error => {
                Utils.writeLog(this.httpClient,this.baseUrl,error);
                if(errorCallback)
                    errorCallback(error);
            }}
        );
    }

    getOtaLevels(callback: any = undefined, errorCallback: any = undefined)
    {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/ota/getotalevels";
        this.httpClient.get(url).subscribe({
            next: response => {
                if(callback)
                    callback(response);
            }, error: error => {
                Utils.writeLog(this.httpClient,this.baseUrl,error);
                if(errorCallback)
                    errorCallback(error);
            }}
        );
    }

    getLastBuildId(buildReleaseType: BuildReleaseType,tthis: any | undefined = undefined, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        Utils.httpGetLastBuildIdByInformationType(this.httpClient, this.baseUrl, tthis, buildReleaseType, callback, errorCallback);
    }

    getRelease(buildReleaseType: BuildReleaseType,tthis: any | undefined = undefined, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        Utils.httpGetReleaseByControllerTypeAndInformationType(this.httpClient, this.baseUrl, tthis, buildReleaseType, callback, errorCallback);
    }

    createBuildForEnv(buildReleaseType: BuildReleaseType, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = this.baseUrl + API_ROUTES.API_DEPLOYMENT;
        const payload = buildReleaseType === BuildReleaseType.GlobalTaskList
            ? ({ GlobalTaskList: true, BuildReleaseType: buildReleaseType })
            : ({ EMTMFGConfiguration: true, BuildReleaseType: buildReleaseType, AutoTrigger: false });
        
        this.httpClient.post<any>(url, payload).subscribe({
            next: result => {
                if (callback)
                    callback(result);
            }, error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback)
                    errorCallback(error);
            }
        });
    }

    getDeploymentStatus(id: number, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = this.baseUrl + API_ROUTES.API_DEPLOYMENT;

        this.httpClient.get<{ description: string }>(`${url}/${id}`).subscribe({
            next: result => {
                if (callback)
                    callback(result?.description);
            }, error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback)
                    errorCallback(error);
            }
        });
    }

    getControllerSoftwareReleases() {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/controllersoftware";
        return this.httpClient
            .get<EMTControllerSoftwareReleases>(url)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
        );
    }

    getPeriphealSoftwareReleases() {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/peripheralsoftware";
        return this.httpClient
            .get<EMTPeripheralSoftwareVersions>(url)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
        );
    }

    getPeripheralSoftwareReleasesByCompatibilityGroup(groupId) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/peripheral-software-version-by-group?groupControllerId=" + groupId;
        return this.httpClient
            .get<PeripheralVersionsDto>(url)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
        );
    }

    updatePeripheralSoftwareVersionsAsMandatory(body: EmtUpdateMandatoryPeripheralVersionsDto) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/mandatory-peripheral-software";
        console.log(body)
        return this.httpClient
            .put<EmtUpdateMandatoryPeripheralVersionResponseViewModel[]>(url, body)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
        );
    }

    getFamilyCodes() {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/familyCodes";
        return this.httpClient
            .get<ComponentFamilyCodes>(url)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
        );
    }

    getSoftwareReleaseLevels() {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/allowed-software-releases/levels";
        return this.httpClient
            .get<EmtAllowedSoftwareReleaseLevelDto[]>(url)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );
    }

    addSoftwareReleaseLevel(level: EmtAllowedSoftwareReleaseLevelDto) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/allowed-software-releases/levels";
        return this.httpClient
            .post<void>(url, level)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );
    }

    getAllowedSoftwareReleases(parameters: { environment: string, tenantId?: string | null }) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/allowed-software-releases";
        const params = new HttpParams()
            .set('environment', parameters.environment ?? '')
            .set('tenantId', parameters.tenantId ?? '');

        return this.httpClient
            .get<EmtAllowedSoftwareRelease[]>(url, { params })
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );
    }

    getMandatoryVersionControllerSoftwareRelease(parameters: { environment: string, tenantId?: string | null }) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/mandatory-controller-software-releases";
        const params = new HttpParams()
            .set('environment', parameters.environment ?? '')
            .set('tenantId', parameters.tenantId ?? '');

        return this.httpClient
            .get<EmtMandatoryVersionSoftwareReleaseDto[]>(url, { params })
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );
    }

    updateAllowedSoftwareReleases(request: UpdateEmtAllowedSoftwareReleasesRequest) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/allowed-software-releases";
        return this.httpClient
            .put<void>(url, request)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );;
    }

    updateMandatoryVersionControllerSoftwareReleases(request: UpdateEmtMandatoryVersionSoftwareReleaseRequest) {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/mandatory-controller-software-releases";
        return this.httpClient
            .put<void>(url, request)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );;
    }

    upsertReleaseNotes(body: any): Observable<EMTSoftwareReleaseNotes[]> {
        const url = this.baseUrl + API_ROUTES.API_EMT + "/upsertSoftwareReleaseNotes";
        return this.httpClient
            .put<EMTSoftwareReleaseNotes[]>(url, body)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );
    }

    getSoftwareReleaseNotesContent(softwareType: string, id: number) {
        const url = `${this.baseUrl}${API_ROUTES.API_EMT}/getreleasenotes/${softwareType}/${id}`;
        return this.httpClient
            .get<EMTReleaseNotesContent>(url)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );
    }

    updateReleaseNotesContent(body: EMTSoftwareReleaseNotesFileChangesRequest) {
        const url = `${this.baseUrl}${API_ROUTES.API_EMT}/updateReleaseNotesContent`;
        return this.httpClient
            .put<UpsertResponse>(url, body)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );

        
    }

    getAvailableModelFiles() {
        const url = `${this.baseUrl}${API_ROUTES.API_EMT}/model-files`;
        return this.httpClient
            .get<EMTModelFile[]>(url)
            .pipe(
                catchError(error => {
                    Utils.writeLog(this.httpClient, this.baseUrl, error);
                    return throwError(() => error);
                })
            );
    }

    getTenantsByEnvironment(env: string, allTenants: Tenant[]) {
        let tenants: any[] = [];
        if (env === 'LA') {
            const laTenants = allTenants
                .filter(x => x.Environment === 'AMS' && x.Tenant !== 'US' && x.Tenant !== 'CA')
                .map(x => ({
                    value: x.Tenant,
                    text: `${x.Tenant} (${x.CountryName})`
                }));

            tenants = [...laTenants];
        }
        else if (env === 'NA') {
            const naTenants = allTenants
                .filter(x => x.Environment === 'AMS' && (x.Tenant === 'US' || x.Tenant === 'CA'))
                .map(x => ({
                    value: x.Tenant,
                    text: `${x.Tenant} (${x.CountryName})`
                }));

            tenants = [...naTenants];
        }
        else {
            tenants = allTenants
                .filter(x => x.Environment === env)
                .map(x => ({
                    value: x.Tenant,
                    text: `${x.Tenant} (${x.CountryName})`
                }));
        }
        return tenants;
    }

    releaseEnvironment(buildReleaseType: BuildReleaseType, tthis: any | undefined = undefined, envId: number, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        Utils.httpReleaseEnvironmentByControllerTypeAndInformationType(this.httpClient, this.baseUrl, tthis, buildReleaseType, envId, callback, errorCallback);
    }

    isEnvironment(level: EquipmentConfigurationLevelDetail): boolean {
        return !level.tenantId && !level.branchNumber && !level.deviceId;
    }

    isTenant(level: EquipmentConfigurationLevelDetail): boolean {
        return !!level.tenantId && !level.branchNumber && !level.deviceId;
    }

    isBranch(level: EquipmentConfigurationLevelDetail): boolean {
        return !!level.tenantId && !!level.branchNumber && !level.deviceId;
    }

    isDevice(level: EquipmentConfigurationLevelDetail): boolean {
        return !!level.tenantId && !!level.branchNumber && !!level.deviceId;
    }

    isTenantBranchOrDevice(level: EquipmentConfigurationLevelDetail): boolean {
        return this.isTenant(level) || this.isBranch(level) || this.isDevice(level);
    }
}